import type { User } from '../types';

/** Public marketing home (same content as legacy `/webdesigned/`). */
export const PUBLIC_WEB_HOME = '/' as const;

export type PortalHomePath = '/manager' | '/staff' | '/client/orders';

export function normalizeAppRole(role: unknown): User['role'] {
  if (role === 'admin') return 'manager';
  if (role === 'employee' || role === 'reception') return 'staff';
  if (role === 'client' || role === 'manager' || role === 'staff') return role;
  return 'client';
}

/** Default landing route after sign-in for each Clerk `publicMetadata.role`. */
export function portalHomePathForRole(role: User['role'] | undefined): PortalHomePath {
  if (role === 'manager') return '/manager';
  if (role === 'staff') return '/staff';
  return '/client/orders';
}

export function pathnameIsPublicWebHome(pathname: string): boolean {
  return pathname === '/' || pathname === '/webdesigned' || pathname === '/webdesigned/';
}
